export function getSelectedDealerId() {
  return new Promise(resolve =>
    resolve(window.parent._dataIsland.crmSettings.dealerId)
  );
}
